import { Controller } from "@hotwired/stimulus";

function regexpEscape(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function htmlEscape(string) {
  return string.replace(/[<>"']/g, '&\\$&');
}

// TODO: Need a way to reset the state of search if there is no query
export default class extends Controller {
  static targets = ['query', 'row', 'cell', 'noMatches'];

  search(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      event.stopPropagation()

      return
    }


    const searchRx = new RegExp(regexpEscape(this.queryTarget.value), 'i');

    let matched = 0;
    let cellCount = 0;

    for (const row of this.rowTargets) {
      if (row.parentElement.tagName === 'THEAD') {
        continue;
      }

      row.classList.add('hidden');
      cellCount = 0;

      for (const cell of row.childNodes) {
        if (cell.nodeType !== Node.ELEMENT_NODE || cell.tagName !== 'TD') {
          continue;
        }

        cellCount += 1;

        if (cell.textContent.match(searchRx)) {
          row.classList.remove('hidden');
        }
      }

      if (!row.classList.contains('hidden')) {
        matched += 1;
      }
    }

    if (matched == 0) {
      this.noMatchesTarget.parentElement.classList.remove('hidden');
      this.noMatchesTarget.classList.remove('hidden');
      this.noMatchesTarget.replaceChildren(document.createTextNode(`No matches found for "${this.queryTarget.value}"`));
    }
    else {
      this.noMatchesTarget.parentElement.classList.add('hidden');
      this.noMatchesTarget.classList.add('hidden');
      this.noMatchesTarget.colSpan = cellCount;
    }
  }
}
